export default "__VITE_ASSET__470ec27e__"